import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/Onboarding.css';

import axios from 'axios';

import { getUser, getAccessToken } from './service/AuthService';


//TODO: move this to an environment variable
const logSubmitUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogsubmit';

const ProblematicLog = () => {
    const user = getUser();
    const token = getAccessToken();
    const username = user !== 'undefined' && user ? user.username: '';

    const [entryTitle, setEntryTitle] = useState('');
    const [entryDescription, setEntryDescription] = useState('');
    const [entryDate, setEntryDate] = useState('');
    const [timeStart, setTimeStart] = useState('');
    const [timeEnd, setTimeEnd] = useState('');
    const [longDescription, setLongDescription] = useState('');
    const [devices, setDevices] = useState('');
    const [digitalTools, setDigitalTools] = useState('');
    const [triggers, setTriggers] = useState('');
    const [tags, setTags] = useState('');
    const [impact, setImpact] = useState('');
    const [impactSeverity, setImpactSeverity] = useState('');
    const [feelingBefore, setFeelingBefore] = useState('');
    const [feelingAfter, setFeelingAfter] = useState('');
    const [practicalUse, setPracticalUse] = useState('');
    const [replacements, setReplacements] = useState('');

    const [lessons, setLessons] = useState('');

    const [errorMessage, setErrorMessage] = useState('');

    const navigate = useNavigate()

    const submitHandler = (event) => {
        event.preventDefault();
        if(entryTitle.trim() === '' || entryDescription.trim() === '' || timeStart.trim() === '' || timeEnd.trim() === '' || longDescription.trim() === '' || devices.trim() === '' || digitalTools.trim() === '' || triggers.trim() === '' || tags.trim() === '' || impact.trim() === '' || impactSeverity.trim() === '' || feelingBefore.trim() === '' || feelingAfter.trim() === '' || practicalUse.trim() === '' || replacements.trim() === '' || lessons.trim() === '' ){
            setErrorMessage('All fields are required');
            return;
        }
        setErrorMessage(null)
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            username: username,
            token: token,
            date: Date.now().toString(),
            entryTitle: entryTitle,
            entryDescription: entryDescription,
            entryDate: entryDate,
            timeStart: timeStart,
            timeEnd: timeEnd,
            longDescription: longDescription,
            devices: devices,
            digitalTools: digitalTools,
            triggers: triggers,
            tags: tags,
            impact: impact,
            impactSeverity: impactSeverity,
            feelingBefore: feelingBefore,
            feelingAfter: feelingAfter,
            practicalUse: practicalUse,
            replacements: replacements,
            lessons: lessons
        }



        axios.post(logSubmitUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            navigate('/progress');
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    }

    return (
        <div className="container">
            <form onSubmit = { submitHandler }>
                 <div class="form-mask">
                    <div class="form-contents">
                        <h3>Problematic Use Entry</h3>
                        <h4>Trust the process</h4>
                        <br />
                        Details
                        <br />
                        <br />
                        <div className="form-group"> <label> Entry Title </label> <br/> <input type="text" value={entryTitle} onChange={event => setEntryTitle(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> Entry Description </label> <br/> <input type="text" value={entryDescription} onChange={event => setEntryDescription(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> Entry Date </label> <br/> <input type="text" value={entryDate} onChange={event => setEntryDate(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> When did the problematic use start? </label> <br/> <input type="text" value={timeStart} onChange={event => setTimeStart(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> When did the problematic use end? </label> <br/> <input type="text" value={timeEnd} onChange={event => setTimeEnd(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> What did you do?: </label> <br /> <input type="text" value={longDescription} onChange={event => setLongDescription(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> What behaviors (tools) -- multiselect (from previous or onboarding) plus other ?: </label> <br /> <input type="text" value={devices} onChange={event => setDevices(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> What websites / apps did you use? (tools) -- multiselect (from previous or onboarding) plus other ?: </label> <br /> <input type="text" value={digitalTools} onChange={event => setDigitalTools(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> Did you notice any triggers? (multi select + option to add other): </label> <br /> <input type="text" value={triggers} onChange={event => setTriggers(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> Select tags that accurately describe the problematic use?: </label> <br /> <input type="text" value={tags} onChange={event => setTags(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> What is the impact this relapse had? (how did it affect you) : </label> <br /> <input type="text" value={impact} onChange={event => setImpact(event.target.value)} /> <br /></div>
                        <div className="form-group"> <label> Rate the impact (1-10): </label> <br /> <input type="text" value={impactSeverity} onChange={event => setImpactSeverity(event.target.value)} /> <br /></div>
                        <br />
                        Guided Introspection <br />
                        <br />
                        <div className="form-group"><label> How were you feeling before the relapse?: </label><br /> <input type="text" placeholder='in hours' value={feelingBefore} onChange={event => setFeelingBefore(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> How were you feeling after the relapse?: </label><br /> <input type="text" value={feelingAfter} onChange={event => setFeelingAfter(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> What use did the relapse have for you? (in the immediate) </label><br /> <input type="text" value={practicalUse} onChange={event => setPracticalUse(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> What could you have done instead? (multi select + other) </label><br /> <input type="text" value={replacements} onChange={event => setReplacements(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> What is something new that you learned from this? </label><br /> <input type="text" value={lessons} onChange={event => setLessons(event.target.value)} /> <br /></div>
                        {errorMessage && <p className="message"> { errorMessage } </p>}
                        <div className="form-group"><input class="submit-bttn" type="submit" value="Submit" /><br /></div>
                    </div>
                 </div>
            </form>
        </div>
    )
}


export default ProblematicLog;